export default __webpack_public_path__ + "static/media/create-template-result.e29c57d8.svg";